import request from '@/http/request'

// 分页展示RFID SKU report
export const getReportPageRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/report/page`, params)
}

// 导出RFID SKU report
export const exportSkuRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/report/sku/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

// 导出RFID SKU lifecycle report
export const exportLifecycleRfid = (params, paramsQuery) => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/report/lifecycle/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true,
    params: paramsQuery
  })
}

// 查询Lifecycle
export const getLifecyclePageRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/report/lifecycle/list`, params)
}
export const getDropDownList = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/report/getDropDownList`)
}
